module.exports = __webpack_public_path__ + "img/up-arrow.2adcf07f.svg";